/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Status_ConnectingInputs */



/**
* | output |
* | --- |
* | "Connecting…" |
*
* @param {Practice_Session_Status_ConnectingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_status_connecting = /** @type {((inputs?: Practice_Session_Status_ConnectingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Status_ConnectingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Verbinden…")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Connexion…")
	return /** @type {LocalizedString} */ ("Connecting…")
});